import { render, staticRenderFns } from "./Unsubscribe.vue?vue&type=template&id=02b09cb8&scoped=true&"
import script from "@/views/Unsubscribe/Unsubscribe.ts?vue&type=script&lang=ts&"
export * from "@/views/Unsubscribe/Unsubscribe.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Unsubscribe/Unsubscribe.scss?vue&type=style&index=0&id=02b09cb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b09cb8",
  null
  
)

export default component.exports